import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton, Skeleton, Stack, Typography } from "@mui/material";

type CardPagerProps = {
  startItem: number;
  endItem: number;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
};

export const CardPager = ({ startItem, endItem, totalItems, currentPage, onPageChange, loading }: CardPagerProps) => {
  if (loading) {
    return (
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-end",
          p: 1.5,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Skeleton variant="rectangular" width={130} height={25} />
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "flex-end",
        p: 1.5,
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }} data-cy="anomalies-pagination-label">
        {startItem}-{endItem} of {totalItems}
      </Typography>
      <IconButton
        size="small"
        data-cy="anomalies-pagination-prev"
        disabled={currentPage === 1}
        onClick={() => {
          onPageChange(currentPage - 1);
        }}
      >
        <ChevronLeftIcon fontSize="inherit" />
      </IconButton>
      <IconButton
        size="small"
        data-cy="anomalies-pagination-next"
        disabled={endItem >= totalItems}
        onClick={() => {
          onPageChange(currentPage + 1);
        }}
      >
        <ChevronRightIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
};
